import {
  Box,
  Disclaimer,
  Div,
  Modal,
  P,
  Pill,
  PropsModal,
  formatDateTimeShort,
  lightTheme,
} from '@vgrubs/components';
import { LocationTrackingSmsEntity } from 'components/src/types/api/location.types';

const withProtocol = (url: string) =>
  /^https?:\/\//i.test(url) ? url : `https://${url}`;

export const TrackingSmsHistoryModal = ({
  modalIsOpen,
  closeModal,
  history,
}: PropsModal & {
  modalIsOpen: boolean;
  history: LocationTrackingSmsEntity[];
}) => {
  return (
    <Modal
      isOpen={modalIsOpen}
      closeModal={closeModal}
      logo={false}
      header="Shipment Link History"
      zIndex={110}
    >
      {history.length === 0 ? (
        <P $center $m="24px 0" $color={lightTheme.darkGray}>
          No shipment links sent yet
        </P>
      ) : (
        history.map((item) => (
          <Box
            key={item.id}
            $flex
            $between
            $alignCenter
            $gap="16px"
            $mb="8"
            $p="12px 20px"
            $pSM="12px 20px"
          >
            <Div style={{ minWidth: 0 }}>
              <P
                $m="0 0 4px"
                $color={lightTheme.primary}
                style={{ wordBreak: 'break-all' }}
                $left
              >
                <a
                  href={withProtocol(item.trackingLink)}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: 'inherit' }}
                >
                  {item.trackingLink}
                </a>
              </P>
              <Disclaimer $left $m="0" $color={lightTheme.darkGray}>
                {formatDateTimeShort(item.createdAt ?? '')}
              </Disclaimer>
            </Div>
            <Div style={{ flexShrink: 0 }}>
              <Pill $background={lightTheme.primary}>
                <Disclaimer $m="0" $color={lightTheme.white} $uppercase>
                  {item.type}
                </Disclaimer>
              </Pill>
            </Div>
          </Box>
        ))
      )}
    </Modal>
  );
};
